import {RouteRecordRaw, createRouter, createWebHashHistory} from "vue-router";
import { useAuth } from "@/store/auth";
import privacyPolicyVue from "./views/privacy-policy.vue";

// Routes are lazy loaded (README: Vue Router > Lazy Loading)
const AuthPages      = () => import("./views/auth.vue");
const CustomersPage  = () => import("./views/customers.vue");
const LeadsPage      = () => import("./views/leads.vue");
const SchedulingPage = () => import("./views/scheduling.vue");
const FakeLandingPage = () => import("./views/fake-landing.vue");
const AccountPage    = () => import("./views/account.vue");
const TransactionsPage = () => import("./views/transactions-table.vue");

//** I'm disabling the req auth while there's no data to show, during dev, for now,  */
export const routes: RouteRecordRaw[] = [
    {
        name: "login",
        path: "/auth",
        component: AuthPages,
        meta: {requiresAuth: false}
    }, {
        path: "/",
        component: SchedulingPage,
        meta: {requiresAuth: true, showMenu: true}
    }, {
        name: "customers",
        path: "/customers",
        component: CustomersPage,
        meta: {requiresAuth: true, showMenu: true, navMenu: true}
    }, {
        name: "leads",
        path: "/leads",
        component: LeadsPage,
        meta: {requiresAuth: true, showMenu: true, navMenu: true}
    }, {
        name: "scheduling",
        path: "/scheduling",
        component: SchedulingPage,
        meta: {requiresAuth: true, showMenu: true, navMenu: true}
    }, {
        name: "FakeLanding",
        path: "/fake-landing",
        component: FakeLandingPage,
        meta: {requiresAuth: true, showMenu: true}
    }, {
        name: "account",
        path: "/account",
        component: AccountPage,
        meta: {requiresAuth: true, showMenu: true}
    }, {
        name: "privacy-policy",
        path: "/privacy-policy",
        component: privacyPolicyVue,
        meta: {requiresAuth: false, showMenu: true}
    }, {
        name: "Kennel Count",
        path: "/kennel-management",
        component: () => import("./views/kennel-count.vue"),
        meta: { requiresAuth: true, showMenu: true, navMenu: true }
    }, {
        name: "Invoices",
        path: "/invoices-table",
        component: () => import("./views/transactions-table.vue"),
        meta: { requiresAuth: true, showMenu: true, navMenu: true }
    }, {
        path: "/transactions-table",
        redirect: "/invoices-table"
    }
];

export const router = createRouter({
    // HTML5 history, no more hash # (README: Vue Router > URL Structure)
    history: createWebHashHistory(),
    routes,
});

export const navMenuRoutes = routes.filter((route) => route.meta?.navMenu);
export const accountRoute = routes.find((route)=>route.name === "account");
router.beforeEach(async (to) => {
    const auth = useAuth();
    await auth.waitForAuth();
    const isLoggedIn = auth.isAuthenticated;

    if(to.meta.requiresAuth && !isLoggedIn) return {name: 'login'};

    if(to.name === 'login' && isLoggedIn) return {name: 'home'};
});

export default router;